import React from 'react';

import {
  Actions,
  Action,
  OpenInNewIcon,
  SyncAltIcon,
} from '@gogame/components';
import {
  ScreenLink,
  SET_FILTERS,
  useScreenDispatch,
  useScreenState,
} from '@gogame/screens';

const COMPARE_MODE = 'compareMode';

const WidgetActions = ({ link, onCompare }) => {
  const screenState = useScreenState();
  const dispatch = useScreenDispatch();

  const { filtersCollection } = screenState;

  const compareMode = filtersCollection.length > 1;

  const handleChangeMode = () => {
    if (compareMode) {
      const [, base] = filtersCollection;
      dispatch({
        type: SET_FILTERS,
        payload: [base],
      });
    } else {
      const [base] = filtersCollection;
      dispatch({
        type: SET_FILTERS,
        payload: onCompare(base),
      });
    }
  };

  return (
    <Actions activeId={compareMode ? COMPARE_MODE : null}>
      <Action
        label={'Open in new tab'}
        icon={<OpenInNewIcon color={'action'} />}
        component={ScreenLink}
        componentProps={{
          link,
          params: screenState,
          target: '_blank',
        }}
      />
      <Action
        label={`Turn ${compareMode ? 'off' : 'on'} Comparing mode`}
        icon={<SyncAltIcon />}
        onClick={handleChangeMode}
        id={COMPARE_MODE}
      />
    </Actions>
  );
};

export default WidgetActions;
